// SDO interface for media links — mirrors desktop URLMediaLink
// Source: D:/Code/TR3AD/v4/Java/Desktop/.../api/link/URLMediaLink

export type MediaType = "IMAGE" | "VIDEO" | "AUDIO";

export interface MediaLink {
    uid: string;
    mediaType: MediaType;
    sourceURL: string;
    caption: string;
    details: string;
    location: string;
    latitude: number;
    longitude: number;
    datetime: number; // epoch milliseconds; 0 = unset
}

export const MEDIA_TYPE_OPTIONS: { value: MediaType; label: string }[] = [
    {value: "IMAGE", label: "Image"},
    {value: "VIDEO", label: "Video"},
    {value: "AUDIO", label: "Audio"},
];
